import { Box, Button, CircularProgress, Container, Grid } from '@mui/material';
import { useGetUserById } from '_api/queries';
import { UsersRouteMap } from '_constants';
import { ProfileCard } from 'components/organisms';
import { ProfileForm } from 'components/organisms/forms';
import { noop } from 'lodash';
import React from 'react';
import { IoMdArrowBack } from 'react-icons/io';
import { useParams } from 'react-router-dom';
import { useNavigateTo } from 'utils';
import { ProfileSubHeader } from 'views/styles';

export const UserDetail = () => {
  const navigate = useNavigateTo();
  const { userId: id } = useParams();
  const userId = id !== undefined ? Number(id) : 0;
  const { data: user, isLoading } = useGetUserById(userId);
  //const { data: me } = useCheckLogin();
  const handleBack = () => {
    navigate(UsersRouteMap.TABLE);
  };

  return (
    <Container>
      {user && !isLoading ? (
        <Box>
          <Button onClick={handleBack} sx={{ justifyContent: 'left' }}>
            {' '}
            <IoMdArrowBack /> Back{' '}
          </Button>
          <Grid container spacing={2} columnSpacing={15}>
            <Grid item xs={12} md={4}>
              <ProfileCard account={user} />
            </Grid>
            <Grid item xs={12} md={8}>
              <Box>
                <ProfileSubHeader>Hello, {user.firstName}</ProfileSubHeader>
                <ProfileForm profile={user} isLoading={isLoading} onSubmit={noop} />
                {/*{user.email === me?.email ? (*/}
                {/*  <>*/}
                {/*    <ProfileSubHeader>Notifications</ProfileSubHeader>*/}
                {/*    <Box>*/}
                {/*      <Typography gutterBottom sx={{ fontSize: '18px', fontWeight: 400 }}>*/}
                {/*        Allow caregivers to contact me by*/}
                {/*      </Typography>*/}
                {/*      <Grid container spacing={2}>*/}
                {/*        <Grid item xs={6}>*/}
                {/*          <FormControlLabel*/}
                {/*            control={<Checkbox />}*/}
                {/*            label={'Admin Messaging'}*/}
                {/*          />*/}
                {/*        </Grid>*/}
                {/*        <Grid item xs={6}>*/}
                {/*          <FormControlLabel*/}
                {/*            control={<Checkbox />}*/}
                {/*            label={'Call the Office'}*/}
                {/*          />*/}
                {/*        </Grid>*/}
                {/*      </Grid>*/}
                {/*    </Box>*/}

                {/*    <Box sx={{ marginTop: '24px' }}>*/}
                {/*      <Typography gutterBottom sx={{ fontSize: '18px', fontWeight: 400 }}>*/}
                {/*        Allow patients to contact me by*/}
                {/*      </Typography>*/}
                {/*      <Grid container spacing={2}>*/}
                {/*        <Grid item xs={6}>*/}
                {/*          <FormControlLabel*/}
                {/*            control={<Checkbox />}*/}
                {/*            label={'Admin Messaging'}*/}
                {/*          />*/}
                {/*        </Grid>*/}
                {/*        <Grid item xs={6}>*/}
                {/*          <FormControlLabel*/}
                {/*            control={<Checkbox />}*/}
                {/*            label={'Call the Office'}*/}
                {/*          />*/}
                {/*        </Grid>*/}
                {/*      </Grid>*/}
                {/*    </Box>*/}
                {/*  </>*/}
                {/*) : null}*/}
              </Box>
            </Grid>
          </Grid>
        </Box>
      ) : (
        <CircularProgress />
      )}
      {/*<Snackbar*/}
      {/*  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}*/}
      {/*  autoHideDuration={5000}*/}
      {/*  onClose={() => setShowSuccess(false)}*/}
      {/*  open={showSuccess}*/}
      {/*>*/}
      {/*  <Alert onClose={() => setShowSuccess(false)} severity="success" variant="filled">*/}
      {/*    User successfully updated.*/}
      {/*  </Alert>*/}
      {/*</Snackbar>*/}
    </Container>
  );
};
